// extracted by mini-css-extract-plugin
module.exports = {"cart-footer":"CartFooter_cart-footer__1hibI","checkout-btn":"CartFooter_checkout-btn__2kVX-"};